import { PageHeader } from "@/components/shared/PageHeader";
import { EmptyState } from "@/components/shared/States";
import { PrimaryButton, SecondaryButton } from "@/components/shared/Buttons";

// Generic placeholder for routes not built in the foundation phase.
export default function Placeholder({ overline, titleLines, description, testId }) {
  return (
    <div data-testid={testId}>
      <PageHeader overline={overline} titleLines={titleLines} description={description} />
      <section className="bg-white py-24 md:py-32">
        <div className="container-asai">
          <EmptyState
            title="This page is coming soon"
            description="We're building this experience as part of the next phase. In the meantime, explore our programs or reach out to our team."
          />
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <PrimaryButton
              href="https://app.atmasammanschoolofai.com/courses"
              target="_blank"
              rel="noopener noreferrer"
              withArrow
              testId={`${testId}-programs-btn`}
            >
              Explore Programs
            </PrimaryButton>
            <SecondaryButton to="/contact" testId={`${testId}-contact-btn`}>
              Contact Us
            </SecondaryButton>
          </div>
        </div>
      </section>
    </div>
  );
}
